import { colors } from '@lmc/common/constants'
import {
  type ImportantContact,
  relationshipOptions,
  roleOptions
} from '@lmc/ts-common'
import { isArray } from 'lodash'
import React from 'react'
import RadioGroup from './RadioGroup'

// Important contacts store their relationship/role as an enum code (e.g. 'I',
// 'R0050'). Resolve it to the human-readable label, falling back to the raw
// value for free-text entries. The two code sets don't overlap.
const relationshipLabelByCode = new Map<string, string>(
  [...roleOptions, ...relationshipOptions].map(({ value, label }) => [
    value,
    label
  ])
)

const resolveRelationshipLabel = (relationship?: string): string =>
  (relationship && relationshipLabelByCode.get(relationship)) ||
  relationship ||
  ''

const renderLabel = (contact: any) => (
  <>
    {contact.name.first} {contact.name.last}
    <span>
      {contact.lpa &&
        isArray(contact.lpaTypes) &&
        contact.lpaTypes.map((type: any) => (
          <span key={type} style={styles.badge}>
            LPA {type}
          </span>
        ))}
    </span>
  </>
)

type PropTypes = {
  name: string
  importantContacts: Array<ImportantContact>
  onComplete: (newState: {
    lpaValue: number
    name: string
    relationship: string
  }) => void
  value: number
}

export const LpaForm = ({
  name,
  onComplete,
  value,
  importantContacts
}: PropTypes) => {
  const onChange = (val: any) => {
    const contact = importantContacts[val]
    if (contact) {
      onComplete({
        lpaValue: val,
        name: `${contact?.name?.first} ${contact?.name?.last}`,
        relationship: resolveRelationshipLabel(contact.relationship)
      })
    } else {
      onComplete({
        lpaValue: val,
        name: '',
        relationship: ''
      })
    }
  }

  return (
    <div className="signature-modal-vertial-center">
      <p style={{ fontWeight: 700, fontSize: 16 }}>
        Who will sign on behalf of {name}?
      </p>
      <RadioGroup
        onChange={onChange}
        value={value}
        options={[
          ...importantContacts.map((contact, i) => ({
            // key: `${contact.name.first}${contact.name.last}`,
            value: i,
            renderLabel: () => renderLabel(contact)
          })),
          {
            label: 'Other',
            value: 'other'
          }
        ]}
      />
    </div>
  )
}

const styles = {
  badge: {
    alignSelf: 'center',
    display: 'inline-block',
    fontWeight: 'bold',
    // float: 'right',
    fontSize: 12,
    padding: '3px 12px',
    background: colors.darkgrey,
    color: 'white',
    marginLeft: 4,
    borderRadius: 15
  }
}

export default LpaForm
